import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'visualOrder',
    pure: false,
    standalone: true
})
export class VisualOrderPipe implements PipeTransform {

  transform(items: any): any {
    return items.sort((a, b) => {
        return (Math.round(a.layout.y / 30) * 30) - (Math.round(b.layout.y / 30) * 30) ||
          (Math.round(a.layout.x / 30) * 30) - (Math.round(b.layout.x / 30) * 30)
      }
      )
  }
}























